import global from '@/utils/global'
/**
 * 初始化redirect uri
 * @param redirectUri Query中的uri
 */
function redirectURIInit(redirectUri){
  // 获取redirect_uri 保存
  // let redirectUri = this.$route.query.redirect_uri
  if (!redirectUri){
    // query 中没有redirect uri， 如果Query中有的话已Query中优先
    let saveRedirectUri = sessionStorage.getItem(global.keys.redirectURIKey)
    if (saveRedirectUri) {
      // sessionStorage 有 redirect uri
      redirectUri = saveRedirectUri
    }else {
      // 没有redirectUri 登录后默认跳转到系统首页
      redirectUri = global.homeDomain
    }
  }
  // 保存redirectURI
  sessionStorage.setItem(global.keys.redirectURIKey, redirectUri)
}

export default {
  redirectURIInit,
}
